export default "__VITE_ASSET__VjDa6abW__"